<template>
  <div class="item">
    <div class="detail-block">
      <div class="primary">
        <span>{{ account.reference }}</span> {{ account.account }}
      </div>
      <div class="secondary">
        {{ account.starts }}
        <span v-if="account.ends">- {{ account.ends }}</span>
      </div>
    </div>

    <div class="amount-block" v-bind:class="{ 'is-debit': account.is_debit }">
      &pound;{{ account.balance }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ChildAccount",
  props: {
    account: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.item {
  font-size: 0.9rem;
  text-align: left;
  color: #777;
  position: relative;
  background-color: white;
  border: 1px solid #dedede;
  padding: 8px;
  border-radius: 8px;
  margin: 5px 0px 10px;

  .date-block {
    position: absolute;
    left: 8px;
    top: 8px;

    .date {
      color: #111;
      font-weight: bold;
      font-size: 1.5rem;
      margin-top: -7px;
      text-align: center;
    }

    .day {
      text-transform: uppercase;
      font-size: 0.7rem;
      text-align: center;
    }
  }

  .detail-block {
    padding-left: 10px;
    padding-right: 95px;

    .primary {
      color: #222;
      font-weight: bold;
      font-size: 1rem;

      span {
        padding-right: 20px;
      }
    }

    .secondary {
      margin-top: 0px;
      font-weight: bold;
      color: #999;
      font-size: 0.8rem;
      min-height: 19px;

      &.is-link {
        cursor: pointer;
        color: $dePurple;
      }
    }
  }

  .amount-block {
    position: absolute;
    right: 8px;
    top: 8px;
    font-weight: bold;
    font-size: 1.5rem;
    color: #222;

    &.is-debit {
      color: darkred;

      &:before {
        content: "-";
      }
    }
  }
}
</style>
